(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-4-names"]) return;
  try {
    
function showHide(classes, action) {
  const clas = classes.split(",");
  for (var i = 0; i < clas.length; i++) {
    document.querySelector(clas[i]).style.display = action;
  }
}

function popupActions(id) {
  var closeModal = document.getElementsByClassName("close")[0];
  var modal = document.getElementById("myModal");
  var btn = document.getElementById(id);
  if (closeModal) {
    closeModal.onclick = function () {
      modal.style.display = "none";
      document.getElementsByTagName('body')[0].classList.remove("overflow");
    }
  }
  if (btn) {
    btn.onclick = function () {
      modal.style.display = "block";
      document.getElementsByTagName('body')[0].classList.add("overflow");
    }
  }
}
function nameOptions(elementIndex, elementValue) {
  if (elementIndex == 'option3') {
    var val = elementValue;

    // Function to clear a specific input field
    function clearInput(selector) {
      document.querySelector(selector).value = '';
    }

    // Determine which inputs to show based on the selection
    if (val.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == 'Un Nom') {
      showHide('.personaliMain .first', 'block');
      showHide('.personaliMain .second', 'none');
      clearInput('.personaliMain .second input'); // Clear the second input

      showHide('.personaliMain .third', 'none');
      clearInput('.personaliMain .third input'); // Clear the third input

    } else if (val.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == 'Deux Noms') {
      showHide('.personaliMain .first', 'block');
      showHide('.personaliMain .second', 'block');
      showHide('.personaliMain .third', 'none');
      clearInput('.personaliMain .third input'); // Clear the third input
    } else if (val.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == 'Trois Noms') {
      showHide('.personaliMain .first', 'block');
      showHide('.personaliMain .second', 'block');
      showHide('.personaliMain .third', 'block');
    }
  }
}

// Function to show/hide elements
function showHide(selector, displayValue) {
  var elements = document.querySelectorAll(selector);
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.display = displayValue;
  }
}


function textCount(event) {  // Pass 'event' as an argument
  var targetid = event.target.id;
  if ($(event.target).next().length == 0) {
    $('<span class="text-count enable helo"><em>0</em>/10</span>').insertAfter($(event.target));
  }
  if ($(event.target).val().length != 0) {
    $(event.target).next().find('em').text($(event.target).val().length);
  } else {
    $(event.target).next().remove();
  }
}

function checkVariant() {
  if (document.getElementsByClassName('variantcheck').length > 0) {
    var getOption3Value = document.getElementsByClassName('variantcheck')[2].dataset['value'];
    nameOptions('option3', getOption3Value);
  }
}

document.addEventListener('variant:change', function (evt) {
  evt.detail.currentlySelectedValues.forEach(function (element) {
    nameOptions(element.index, element.value);
  })
});

window.addEventListener("DOMContentLoaded", function () {
  popupActions("font-previewbtn");
  checkVariant();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-closed"]) return;
  try {
    
function showHide(classes, action) {
  const clas = classes.split(",");
  for (var i = 0; i < clas.length; i++) {
    document.querySelector(clas[i]).style.display = action;
  }
}

function popupActions(id) {
  var closeModal = document.getElementsByClassName("close")[0];
  var modal = document.getElementById("myModal");
  var btn = document.getElementById(id);
  if (closeModal) {
    closeModal.onclick = function () {
      modal.style.display = "none";
      document.getElementsByTagName('body')[0].classList.remove("overflow");
    }
  }
  if (btn) {
    btn.onclick = function () {
      modal.style.display = "block";
      document.getElementsByTagName('body')[0].classList.add("overflow");
    }
  }
}
function nameOptions(elementIndex, elementValue) {
  if (elementIndex == 'option2') {
    var val = elementValue;

    // Function to clear a specific input field
    function clearInput(selector) {
      document.querySelector(selector).value = '';
    }

    // Determine which inputs to show based on the selection
    if (val.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == 'Un Nom') {
      showHide('.personaliMain .first', 'block');
      showHide('.personaliMain .second', 'none');
      clearInput('.personaliMain .second input'); // Clear the second input

      showHide('.personaliMain .third', 'none');
      clearInput('.personaliMain .third input'); // Clear the third input

    } else if (val.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == 'Deux Noms') {
      showHide('.personaliMain .first', 'block');
      showHide('.personaliMain .second', 'block');
      showHide('.personaliMain .third', 'none');
      clearInput('.personaliMain .third input'); // Clear the third input
    } else if (val.normalize("NFD").replace(/[\u0300-\u036f]/g, "") == 'Trois Noms') {
      showHide('.personaliMain .first', 'block');
      showHide('.personaliMain .second', 'block');
      showHide('.personaliMain .third', 'block');
    }
  }
}

// Function to show/hide elements
function showHide(selector, displayValue) {
  var elements = document.querySelectorAll(selector);
  for (var i = 0; i < elements.length; i++) {
    elements[i].style.display = displayValue;
  }
}


function textCount(event) {  // Pass 'event' as an argument
  var targetid = event.target.id;
  if ($(event.target).next().length == 0) {
    $('<span class="text-count enable helo"><em>0</em>/10</span>').insertAfter($(event.target));
  }
  if ($(event.target).val().length != 0) {
    $(event.target).next().find('em').text($(event.target).val().length);
  } else {
    $(event.target).next().remove();
  }
}

function checkVariant() {
  if (document.getElementsByClassName('variantcheck').length > 0) {
    var getOption3Value = document.getElementsByClassName('variantcheck')[0].dataset['value'];
    nameOptions('option2', getOption3Value);
  }
}

document.addEventListener('variant:change', function (evt) {
  evt.detail.currentlySelectedValues.forEach(function (element) {
    nameOptions(element.index, element.value);
  })
});

window.addEventListener("DOMContentLoaded", function () {
  popupActions("font-previewbtn");
  checkVariant();
});


  } catch(e) { console.error(e); }
})();
})();
